/**
 * Default / Shared > Slider
 */

import {
	extend,
	getRootVar
} from "../../../../shared/utils";
import SelectorEngine from '../../../../shared/dom/selector-engine';
import Slider from '../../../../shared/components/slider';

// ------
// Privat
// ------

const sliderDefault = (o = {}) => {
	const collection = SelectorEngine.find('[data-c="slider"]');

	for (const element of collection) {
		Slider.init(element, o);
	}
};

const sliderFade = (o = {}) => {
	const collection = SelectorEngine.find('[data-c="slider-fade"]');

	if (collection.length > 0) {
		const _o = extend({}, o, {
			autoHeight: true,
			effect    : 'fade',
			fadeEffect: {
				crossFade: true
			}
		});

		for (const element of collection) {
			Slider.init(element, _o);
		}
	}
};

// ------
// Public
// ------

const init = () => {
	const transitionMultiplier = parseInt((getRootVar('global-duration-multiplier') ?? 0), 10);
	const speed                = (transitionMultiplier === 1) ? 500 : 0;

	const o = {
		spaceBetween: 16,
		speed : speed,
		breakpoints : {
			// when window width is >= 992px
			992: {
				spaceBetween: 32
			}
		}
	};

	sliderDefault(o);
	sliderFade(o);
};

// Export
export default init;
